import {
  EOnboardingModule,
  EOnboardingStep,
  EOnboardingStepStatus,
  EOnboardingSurvey,
  EOnboardingTutorial,
} from './definitions';

export default {
  greeting: 'Glad to see you in edna Pulse!',
  modulesTitle: 'edna Pulse modules for your business',
  modules: {
    [EOnboardingModule.MAX]: {
      title: 'MAX simplified registration',
      hint: 'available exclusively in edna',
    },
    [EOnboardingModule.DIALOGS]: {
      title: 'Built-in messaging module',
      hint: 'communicate directly in edna Pulse',
    },
    [EOnboardingModule.TRIGGERS]: {
      title: 'Create communication scenarios',
      hint: 'no IT team required',
    },
    [EOnboardingModule.CASCADES]: {
      title: 'Backup channel in a messaging cascade',
      hint: 'reliable delivery',
    },
    [EOnboardingModule.INTEGRATION]: {
      title: 'API for easy integration',
      hint: 'and ready-made modules',
    },
  },
  stepsTitle: 'Simple steps to managing communications',
  steps: {
    [EOnboardingStep.COMPANY_DETAILS]: {
      [EOnboardingStepStatus.INITIAL]: 'Fill in company details',
      [EOnboardingStepStatus.COMPLETED]: 'Details filled in',
      action: 'Fill in',
    },
    [EOnboardingStep.CHANNEL]: {
      [EOnboardingStepStatus.INITIAL]: 'Connect a communication channel',
      [EOnboardingStepStatus.IN_PROGRESS]:
        'The communication channel is connected. <0>Registration is in progress and will be completed soon </0>',
      [EOnboardingStepStatus.COMPLETED]: 'Channel connected',
      action: 'Connect',
    },
    [EOnboardingStep.LICENSE]: {
      [EOnboardingStepStatus.INITIAL]: 'Pay for the license',
      [EOnboardingStepStatus.IN_PROGRESS]:
        'Balance is replenished. <0>Funds will be charged automatically once the channel is connected</0>',
      [EOnboardingStepStatus.COMPLETED]: 'License paid',
      action: 'Top up balance',
    },
    [EOnboardingStep.INTEGRATION]: {
      [EOnboardingStepStatus.INITIAL]: 'Connect integration',
      [EOnboardingStepStatus.COMPLETED]: 'Integration connected',
      action: 'To integrations',
    },
    [EOnboardingStep.TEMPLATE]: {
      [EOnboardingStepStatus.INITIAL]: 'Approve the template',
      [EOnboardingStepStatus.IN_PROGRESS]:
        'The template has been sent for registration. <0>Waiting for activation</0>',
      [EOnboardingStepStatus.COMPLETED]: 'Template approved',
      action: 'Select template',
    },
  },
  tariffs: {
    title: 'Channels',
  },
  survey: {
    title: 'What tasks do you want to solve?',
    hint: 'One question to help us customize your account:',
    questions: {
      [EOnboardingSurvey.BROADCASTS]: {
        title: 'Broadcasts',
        hint: 'I want to send messages to my recipients',
      },
      [EOnboardingSurvey.INCOMING_MESSAGES]: {
        title: 'Incoming messages',
        hint: 'I need to work with incoming messages',
      },
      [EOnboardingSurvey.INTEGRATION]: {
        title: 'System integration',
        hint: 'I have a CRM/CDP and want to integrate it',
      },
      [EOnboardingSurvey.EASY_OPERATION]: {
        title: 'Simple interface',
        hint: 'I want to do everything in a simple interface',
      },
    },
  },
  tutorial: {
    [EOnboardingTutorial.TRIGGERS]: {
      title: 'Scenarios in edna Pulse',
      hint: 'Automation scenarios streamline customer communication',
      docs: 'Documentation',
      pointsTitle: 'How to create a scenario:',
      points: ['Connect a channel', 'Set a start condition', 'Select an action'],
    },
    [EOnboardingTutorial.CASCADES]: {
      title: 'Cascades in edna Pulse',
      hint: 'Cascades ensure message delivery if the primary channel is unavailable',
      docs: 'Documentation',
      pointsTitle: 'How to create a cascade:',
      points: ['Register at least 2 channels', 'Set a start condition', 'Select an action'],
    },
    [EOnboardingTutorial.DIALOGS]: {
      title: 'Dialogues in edna Pulse',
      hint: 'Chat with recipients directly from your account',
      docs: 'Documentation',
      pointsTitle: 'Start a conversation:',
      points: ['Connect a channel', 'Upload a recipient list', 'Send an outbound message'],
    },
    [EOnboardingTutorial.BROADCASTS]: {
      title: 'Broadcasts in edna Pulse',
      hint: 'A tool for client messaging',
      docs: 'Documentation',
      pointsTitle: 'How to schedule a broadcast:',
      points: ['Connect a channel', 'Upload a recipient list', 'Configure the settings'],
    },
  },
};
